import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

// TODO: add validation
const createTransactionValidation = Yup.object().shape({
  
});

export default createTransactionValidation;
